"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const StyledMiddleControlButton = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "MiddleControlButton__StyledMiddleControlButton",
  componentId: "components-web__sc-1um2s37-0"
})(_ref => {
  let {
    isHidden,
    width,
    height,
    background
  } = _ref;
  return {
    width,
    height,
    borderRadius: '50%',
    transition: 'opacity 0.4s',
    opacity: isHidden ? 0 : 1,
    background,
    display: 'flex',
    justifyContent: 'center',
    border: 'none',
    padding: 0,
    font: 'inherit',
    cursor: 'pointer',
    alignItems: 'center'
  };
});
const MiddleControlButton = _ref2 => {
  let {
    icon: Icon,
    isHidden = false,
    onClick,
    onFocus,
    tokens,
    variant,
    ...rest
  } = _ref2;
  const {
    width,
    height,
    background,
    iconColor
  } = (0, _componentsBase.useThemeTokens)('VideoMiddleControlButton', tokens, variant);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMiddleControlButton, {
    isHidden: isHidden,
    onClick: onClick,
    onFocus: onFocus,
    width: width,
    height: height,
    background: background,
    ...selectProps(rest),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
      color: iconColor,
      size: 24
    })
  });
};
MiddleControlButton.propTypes = {
  ...selectedSystemPropTypes,
  icon: _propTypes.default.elementType.isRequired,
  isHidden: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onFocus: _propTypes.default.func
};
var _default = exports.default = MiddleControlButton;